import React from 'react'

function ErrorIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
      {...props}
    >
      <path
        fill="#FF1010"
        d="M12.272 4.962c.772-1.323 2.684-1.323 3.456 0l10.518 18.03c.777 1.334-.184 3.008-1.728 3.008H3.482c-1.544 0-2.505-1.674-1.727-3.008l10.517-18.03z"
      ></path>
      <path
        fill="#fff"
        d="M15.333 20.833a1.167 1.167 0 11-2.333 0 1.167 1.167 0 012.333 0zm0-3.834A1.167 1.167 0 1113 17v-4.666a1.167 1.167 0 112.333 0v4.666z"
      ></path>
    </svg>
  )
}

export default ErrorIcon
